import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { Horizontal, NothingMessage, Vertical } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { Form } from 'antd'
import React, { useState } from 'react'

import { Alternates } from './Alternates/Alternates'
import { Blends } from './Blends/Blends'
import { Details } from './Details/Details'

export function ProductRowExpand({ data: selectedProduct, metadata, products, updateProduct, gridAPIRef }) {
  const [editMode, setEditMode] = useState(false)

  const updateRow = (newRow) => {
    const rowToUpdate = gridAPIRef?.current.getRowNode(selectedProduct.id)
    rowToUpdate.data = { ...rowToUpdate.data, ...newRow }
    gridAPIRef?.current.applyTransaction({ update: [rowToUpdate.data] })
    gridAPIRef?.current.refreshCells({ rowNodes: [rowToUpdate.data] })
  }
  const onSave = (formData) => {
    const copy = { ...selectedProduct, ...formData }
    api.updateProduct(copy).then((resp) => {
      updateRow(resp.data)
      setEditMode(false)
    })
  }

  return (
    <Horizontal height={'100%'} background='bg-1'>
      <Form onFinish={onSave} onFinishFailed={NothingMessage}>
        <Vertical style={{ maxWidth: '400px', minWidth: 400 }} flex={1}>
          <Details selectedProduct={selectedProduct} groups={metadata.groups} updateRow={updateRow} />
          <Alternates
            products={products}
            selectedProduct={selectedProduct}
            editMode={editMode}
            setEditMode={setEditMode}
          />
        </Vertical>
      </Form>
      <Vertical border='left' style={{ maxHeight: '100%', height: 'inherit' }} scroll>
        <Blends products={products} selectedProduct={selectedProduct} updateRow={updateRow} />
      </Vertical>
    </Horizontal>
  )
}
